var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-content',{attrs:{"blocks":_vm.blocks,"serializers":_vm.serializers}})}
var staticRenderFns = []

export { render, staticRenderFns }